<template>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit, invalid }"
    slim
  >
    <form
      role="form"
      class="form-horizontal"
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ $t("ACCOUNT_BILLING_ADD_FUNDS_CURRENT_BALANCE") }}
          <i
            v-tooltip.right="$t('ACCOUNT_BILLING_ADD_FUNDS_CURRENT_BALANCE_TT')"
            class="fa fa-question-circle m-l-5"
          />
        </label>

        <div class="col-sm-1 p-t-7">
          ${{ billingPlan.accountBalance }}
        </div>
      </div>
      <Field
        :label="$t('ACCOUNT_BILLING_ADD_FUNDS_AMOUNT')"
        :has-tooltip="true"
        :tooltip-text="$t('ACCOUNT_BILLING_ADD_FUNDS_AMOUNT_TT')"
      >
        <template #element>
          <ValidationProvider
            v-slot="{ classes, errors }"
            ref="addFundsAmount"
            rules="required|min_value:25|max_value:10000"
            slim
          >
            <div :class="classes">
              <div class="col-sm-3">
                <input
                  v-model="funds.amount"
                  type="number"
                  name="addFundsAmount"
                  autocomplete="off"
                  class="form-control"
                />
              </div>
              <label
                v-if="errors && errors[0]"
                v-t="'ACCOUNT_BILLING_INVALID_AMOUNT'"
                class="col-sm-4 form-group__label-required"
              />                  
              <label
                v-else
                v-t="'REQUIRED'"
                class="col-sm-4 form-group__label-required"
              />
            </div>
          </ValidationProvider>
        </template>
      </Field>
      <Field
        :label="$t('ACCOUNT_BILLING_ADD_FUNDS_SELECT_CARD')"
        :has-tooltip="true"
        :tooltip-text="$t('ACCOUNT_BILLING_ADD_FUNDS_SELECT_CARD_TT')"
      >
        <template #element>
          <ValidationProvider
            v-slot="{ classes, errors }"
            ref="addFundsCreditCard"
            rules="required"
            slim
          >
            <div :class="classes">
              <div class="col-sm-5">
                <SearchableDropdown
                  v-model="funds.creditCardId"
                  :config="creditCardOptions"
                />
              </div>
              <label
                v-t="'REQUIRED'"
                class="col-sm-3 form-group__label-required"
              />
            </div>
          </ValidationProvider>
        </template>
      </Field>
      <div class="row display-flex flex--justify-end p-t-25">
        
        <PrimaryButton
          :disabled="invalid || isAddingFunds"
          :show-loader-on-form="isAddingFunds"
          class="p-r-25 p-l-25"
        >
          <span v-t="'ADD'" />
        </PrimaryButton>
        <button
          v-t="'CANCEL'"
          class="btn btn-danger m-l-15"
          @click="onCancel"
        />
      </div>
    </form>
  </ValidationObserver>
  
</template>

<script>
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { mapActions, mapGetters, mapState } from 'vuex';
import { STATUS_ERROR, STATUS_SUCCESS, STATUS_PENDING } from '@/store/helpers';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';

export default {
  name: 'AddFundsForm',
  components: {
    Field,
    SearchableDropdown
  },
  data() {
    return {
      funds: {
        amount: '',
        creditCardId: ''
      },
    };
  },
  computed: {
    ...mapGetters('billingSettingsStore', ['addAccountBalanceStatus']),
    ...mapState('billingSettingsStore', ['billingPlan', 'creditCards']),
    creditCardOptions() {
      return {
        options: this.creditCards,
        ...{
          reduce: (option) => option.id,
          label: 'name',
        },
        placeholder: this.$t('ACCOUNT_BILLING_ADD_FUNDS_SELECT_CARD_PLACEHOLDER')
      };
    },
    isAddingFunds() {
      return this.addAccountBalanceStatus.status === STATUS_PENDING;
    }
  },
  methods: {
    ...mapActions('billingSettingsStore', ['addAccountBalance', 'getBillingPlan']),
    async onSubmit() {
      await this.addAccountBalance(this.funds);

      if (this.addAccountBalanceStatus.status === STATUS_SUCCESS) {
        utilities.showToaster(STATUS_SUCCESS, this.$t('ACCOUNT_BILLING_ADD_FUNDS_SUCCESS'));
        this.getBillingPlan();
        this.onCancel();
      }
      if (this.addAccountBalanceStatus.status === STATUS_ERROR) {
        utilities.errorHandler(this.addAccountBalanceStatus.error);
      }

    },
    onCancel() {
      this.$emit('cancel');
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>